const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/sagas/trackingSaga.ts';
import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { TrackingData } from 'App/defs/trackingDefs';
import { showUncaughtErrorDialog } from '@cistec/common_web/actions/uiActions';
import { ACTION_TYPE_PATAPP_TRACKING_FROM_STORAGE } from 'App/actions/tracking';

const Log = Logger('trackingSaga');

export function* trackingSaga(): SagaIterator {
    try {
        const trackingState = localStorage.getItem(TrackingData) as string;

        if (trackingState) {
            yield put({ type: ACTION_TYPE_PATAPP_TRACKING_FROM_STORAGE, payload: trackingState });
        }
    } catch (exc) {
        yield put(showUncaughtErrorDialog('trackingSaga', exc));
        Log.error('EXCEPTION caught: ', exc);
    }
}
